import { CustomerResponse } from "../api/CustomerService";

export const sortCustomers = (customers: CustomerResponse) => {
    return customers.data.sort((a: any, b: any) => {
        const nameA = (a.name || a.surename || "").toLowerCase();
        const nameB = (b.name || b.surename || "").toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
    });
};